/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Edit_Description_BeforeInputs */

const fr_vehicle_action_edit_description_before = /** @type {(inputs: Vehicle_Action_Edit_Description_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merci de prendre connaissance `)
};

const en_vehicle_action_edit_description_before = /** @type {(inputs: Vehicle_Action_Edit_Description_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please read `)
};

/**
* | output |
* | --- |
* | "Please read" |
*
* @param {Vehicle_Action_Edit_Description_BeforeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_description_before = /** @type {((inputs?: Vehicle_Action_Edit_Description_BeforeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Description_BeforeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_description_before(inputs)
	return en_vehicle_action_edit_description_before(inputs)
});